import { GoMail } from "react-icons/go"

export default {
  login: 'mdakram09',
  id: 60223957,
  node_id: 'MDQ6VXNlcjQyMTMzMzg5',
  avatar_url: 'https://avatars.githubusercontent.com/u/60223957?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/mdakram09',
  html_url: 'https://github.com/mdakram09',
  followers_url: 'https://api.github.com/users/mdakram09/followers',
  following_url:
    'https://api.github.com/users/mdakram09/following{/other_user}',
  gists_url: 'https://api.github.com/users/mdakram09/gists{/gist_id}',
  starred_url:
    'https://api.github.com/users/mdakram09/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/mdakram09/subscriptions',
  organizations_url: 'https://api.github.com/users/mdakram09/orgs',
  repos_url: 'https://api.github.com/users/mdakram09/repos',
  events_url: 'https://api.github.com/users/mdakram09/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/mdakram09/received_events',
  type: 'User',
  site_admin: false,
  name: 'Md Akram Khan',
  company: 'Intern at iNeuron Intelligence Pvt Ltd',
  blog: 'https://mdakram09.netlify.app/',
  location: 'Kolkata, India',
  email: 'iamakramkhan01@gmail.com',
  hireable: 'yes',
  bio: 'Full Stack Web Developer and Machine Learning enthusiast',
  twitter_username: 'mdakram09',
  public_repos: 132,
  public_gists: 0,
  followers: 2,
  following: 92,
  created_at: '2018-08-06T06:48:23Z',
  updated_at: '2020-07-08T05:01:32Z',
};
